import moment, { Moment } from "moment";

export interface PrizeSupplierDTO {
  id: number;
  lastUpdate: string;
  priceMargin: number;
  webhook: string;
  type: string;
}

export class PrizeSupplier {
  private _id: number = 0;
  private _lastUpdate: Moment = moment();
  private _priceMargin: number = 0;
  private _webhook: string = "";
  private _type: string = "";

  static create(prizeSupplier: PrizeSupplierDTO): PrizeSupplier {
    const instance = new PrizeSupplier();

    instance._id = prizeSupplier.id;
    instance._lastUpdate = moment(prizeSupplier.lastUpdate);
    instance._priceMargin = prizeSupplier.priceMargin || 0;
    instance._webhook = prizeSupplier.webhook;
    instance._type = prizeSupplier.type;

    return instance;
  }

  public get id() {
    return this._id;
  }

  public get lastUpdate() {
    return this._lastUpdate.format("DD.MM.YYYY");
  }

  public get priceMargin() {
    return this._priceMargin;
  }

  public get webhook() {
    return this._webhook;
  }

  public get type() {
    return this._type;
  }
}
